<template>
  <span v-if="queue.status !== null">
      <div>
        <em class="fas fa-sync text-warning" v-if="queue.status === 'processing'"></em>
        <em class="fas fa-check text-success" v-if="queue.status === 'done'"></em>
      </div>
      <vx-tooltip color="danger" :text="queue.message" style="float: left; margin-right: 5px;">
        <em class="fas fa-times text-danger" v-if="queue.status === 'error'"></em>
      </vx-tooltip>
  </span>
</template>

<script>
export default {
  name: "dispersion-queue-status",
  props: ['queue']
}
</script>

<style scoped>

</style>
